export const createManualPathName = (manualTopic: string, manualDate: string, manualId: number) => {
	// remove characters from manualTopic

	let cleanTopicString = manualTopic.replaceAll(/[()–]/g, '').replaceAll(/[^\w]/g, '-')
	return cleanTopicString + '-' + manualDate + '-' + manualId.toString()
}
